import { ARTICLES_URL } from '@/modules/article/article.constants';
import { resolveCurrentUser } from '@/modules/user/user.service';
import { createEmptyComponent } from '@/router/route.service';

export default [
  {
    path: ARTICLES_URL.path,
    redirect: '/',
    beforeEnter: resolveCurrentUser,
    component: { render: createEmptyComponent },
    children: [
      {
        ...ARTICLES_URL.view,
        component: () => import('@/modules/article/views/ArticleViewPage.vue'),
      },
      {
        ...ARTICLES_URL.track,
        component: () => import('@/modules/article/views/ArticleViewPage.vue'),
      },
      {
        ...ARTICLES_URL.edit,
        component: () => import('@/modules/article/views/ArticleEditPage.vue'),
      },
      {
        ...ARTICLES_URL.create,
        component: () => import('@/modules/article/views/ArticleEditPage.vue'),
      },
      {
        ...ARTICLES_URL.answer,
        component: () => import('@/modules/article/views/ArticleEditPage.vue'),
      },
      {
        ...ARTICLES_URL.notfound,
        component: () => import('@/modules/article/views/ArticleNotFound.vue'),
      },
      {
        ...ARTICLES_URL.forbidden,
        component: () => import('@/modules/article/views/ArticleForbidden.vue'),
      },
      {
        ...ARTICLES_URL.denied,
        component: () => import('@/modules/article/views/ArticleDenied.vue'),
      },
    ],
  },
];

export function goToForbiddenArticle($router, creating) {
  $router.push({
    name: ARTICLES_URL.forbidden.name,
    params: { creating },
  });
}

export function goToDeniedArticle($router) {
  $router.push({
    name: ARTICLES_URL.denied.name,
  });
}

export function goToArticleNotFound($router) {
  $router.push({
    name: ARTICLES_URL.notfound.name,
  });
}

export function goToOpenArticle($router, article) {
  $router.push({
    name: ARTICLES_URL.view.name,
    params: { id: article.id },
    query: { title: article.slug },
  });
}

export function goToCreateArticle($router) {
  $router.push({
    name: ARTICLES_URL.create.name,
  });
}

export function goToAnswerWithArticle($router, question) {
  $router.push({
    name: ARTICLES_URL.answer.name,
    params: { question_id: question.id },
  });
}
